import { isProduction } from "../../services/config";

/**
 * Development-only logging utility.
 * Logs are suppressed in production environment.
 */

type LogLevel = "log" | "warn" | "info" | "debug" | "error";

function createDevLogger(level: LogLevel) {
  return (...args: unknown[]): void => {
    if (!isProduction) {
      console[level](...args);
    }
  };
}

export const devLog = createDevLogger("log");
export const devWarn = createDevLogger("warn");
export const devInfo = createDevLogger("info");
export const devDebug = createDevLogger("debug");
export const devError = createDevLogger("error");
